import { Types } from './actionTypes';

export const ActionCreators = {
  login: (user) => ({ type: Types.LOGIN, payload: { user } }),
  logout: (user) => ({ type: Types.LOGOUT, payload: { user } }),
  selectCustomer: (customer) => ({ type: Types.SELECT_CUSTOMER, payload: customer }),
  selectSale: (sale) => ({ type: Types.SELECT_SALE, payload: sale }),
}